import { Action } from "@/api-schema-enums";
import { useAbility } from "@/casl-provider";
import { generateUuidV4Regex } from "@/common/helpers/utils";
import { ForbiddenView } from "@/views/common/forbidden.view";
import { NotFoundView } from "@/views/common/notfound.view";
import { Route, Switch } from "wouter";
import { ModelGenerationCreateView } from "./create/model-generation-create.view";
import { ModelGenerationView } from "./model-generation.view";
import { ModelGenerationUpdateView } from "./update/model-generation-update.view";

export function ModelGenerationRoutes() {
  const ability = useAbility();
  const modelGenerationUuidRegex = generateUuidV4Regex({ paramName: "uuid", suffix: "/update" });
  const canManage = ability.can(Action.Manage, "ModelGeneration");

  return (
    <Switch>
      <Route path="/" component={ModelGenerationView} />
      <Route path="/create" component={canManage ? ModelGenerationCreateView : ForbiddenView} />
      <Route path={modelGenerationUuidRegex} component={canManage ? ModelGenerationUpdateView : ForbiddenView} />
      <Route component={NotFoundView} />
    </Switch>
  );
}
